import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f024d29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anchor-navigation" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "dropdown-loading"
}
const _hoisted_4 = {
  key: 0,
  class: "where-used-banner"
}
const _hoisted_5 = { class: "where-used-banner-text" }
const _hoisted_6 = { class: "where-used-banner-button-text" }

import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import useRouteParams from '@/composables/useRouteParams'
import useDetailPage from './useDetailPage'
import { usePartCollectionsData } from '@/composables/collections/usePartCollectionsData'
import { usePartCollectionSearch } from '@/composables/collections/usePartCollectionSearch'

import PillsTag from '@/components/common/PillsTag.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AnchorNavigation',
  setup(__props) {

const store = useStore()
const { id } = useRouteParams()

const {
  content,
  isPart,
  showComments,
  showRelated,
  showSuggestions,
  showWhereUsed,
  showAttachments,
  showPartCollections
} = useDetailPage()

const {
  clearSearch: clearPartCollectionSearch
} = usePartCollectionSearch(
  id.value,
  () => {}
)

const partCollectionsOpen = ref(false)

const isPagePart = computed(() => isPart.value && content.value.pagePartId !== '')

const showPartInformationBanner = computed(() => store.state.user.showPartInformationBanner)

const hideBanner = computed(() =>
  (!isPart.value || isPagePart.value) ||
  !showPartInformationBanner.value ||
  (store.state.user.hidePagesInSearch && store.state.user.hideBooksInSearch)
)

/**
 * AnchorNavigation is only consuming shared state here.
 * It must not call loadCollections() or resetIfOwner().
 */
const {
  collections,
  selectCollection,
  loadMoreCollections,
  hasMoreCollections,
  isLoadingMoreCollections
} = usePartCollectionsData(
  id.value,
  (part: any) => part
)

function isNearBottom(el: HTMLElement, threshold = 48) {
  return el.scrollTop + el.clientHeight >= el.scrollHeight - threshold
}

async function handleDropdownScroll(event: Event) {
  const el = event.target as HTMLElement | null
  if (!el) return
  if (!hasMoreCollections.value) return
  if (isLoadingMoreCollections.value) return
  if (!isNearBottom(el)) return

  await loadMoreCollections()
}

const navigateTo = (anchor: string) => {
  switch (anchor) {
    case 'Related':
      document.getElementById(anchor)?.scrollIntoView({ block: 'center' })
      break
    default:
      document.getElementById(anchor)?.scrollIntoView()
  }
}

const handleCollectionSelection = (collectionId: number) => {
  clearPartCollectionSearch()
  navigateTo('PartCollections')
  selectCollection(collectionId)
  partCollectionsOpen.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", null, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('goTo')) + ":", 1),
        (_unref(showComments))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('Comments')))
            }, [
              _createVNode(PillsTag, {
                text: _ctx.$tc('comment', 2),
                "text-color": "is-info",
                "display-empty-pill": true,
                total: _unref(content).comments.total
              }, null, 8, ["text", "total"])
            ]))
          : _createCommentVNode("", true),
        (_unref(showRelated))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('Related')))
            }, [
              _createVNode(PillsTag, {
                text: _ctx.$t('related'),
                "text-color": "is-info",
                "display-empty-pill": true,
                total: _unref(content).related.total
              }, null, 8, ["text", "total"])
            ]))
          : _createCommentVNode("", true),
        (_unref(showAttachments))
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateTo('Attachments')))
            }, [
              _createVNode(PillsTag, {
                text: _ctx.$tc('attachment', 2),
                "text-color": "is-info",
                "display-empty-pill": true,
                total: _unref(content).attachments.total
              }, null, 8, ["text", "total"])
            ]))
          : _createCommentVNode("", true),
        (_unref(showWhereUsed))
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateTo('WhereUsed')))
            }, [
              _createVNode(PillsTag, {
                text: _ctx.$t('whereUsed'),
                "text-color": "is-info",
                "display-empty-pill": true,
                total: _unref(content).whereused.total
              }, null, 8, ["text", "total"])
            ]))
          : _createCommentVNode("", true),
        (_unref(showSuggestions))
          ? (_openBlock(), _createElementBlock("a", {
              key: 4,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateTo('Suggestions')))
            }, [
              _createVNode(PillsTag, {
                text: _ctx.$tc('suggestion', 2),
                "text-color": "is-info",
                "display-empty-pill": true,
                total: _unref(content).suggestions.total
              }, null, 8, ["text", "total"])
            ]))
          : _createCommentVNode("", true),
        (_unref(showPartCollections))
          ? (_openBlock(), _createElementBlock("div", {
              key: 5,
              class: "part-collections-menu",
              onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (partCollectionsOpen.value = true)),
              onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (partCollectionsOpen.value = false))
            }, [
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (navigateTo('PartCollections')))
              }, [
                _createVNode(PillsTag, {
                  text: _ctx.$tc('partCollection', 2),
                  "text-color": "is-info",
                  "display-empty-pill": true,
                  total: _unref(content).partCollectionsCount ?? 0
                }, null, 8, ["text", "total"])
              ]),
              (partCollectionsOpen.value && _unref(collections).length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "part-collections-dropdown",
                    onScroll: handleDropdownScroll
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collections), (collection) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: collection.id,
                        class: "dropdown-item-button",
                        onClick: _withModifiers(($event: any) => (handleCollectionSelection(collection.id)), ["stop"])
                      }, _toDisplayString(collection.name), 9, _hoisted_2))
                    }), 128)),
                    (_unref(isLoadingMoreCollections))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('loading')) + "... ", 1))
                      : _createCommentVNode("", true)
                  ], 32))
                : _createCommentVNode("", true)
            ], 32))
          : _createCommentVNode("", true)
      ])
    ]),
    (!hideBanner.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('partVerificationInstructions')), 1),
          _createElementVNode("button", {
            class: "button where-used-banner-button",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (navigateTo('WhereUsed')))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('viewWhereUsed')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})